import isPropValid from "@emotion/is-prop-valid";

/**
 * Emotion provides a filter function to determine which props are forwarded to the DOM element.
 */
export const excludePropsFromForwarding = (...args: string[]) => ({
  shouldForwardProp: (prop: string) =>
    !args.includes(prop) && isPropValid(prop),
});
